import type { FaireProductEntity } from "../../entity_types/product";

export const p_mfj48a3q29: FaireProductEntity = {
  token: "p_mfj48a3q29",
  type: "product",
  name: "LM-BG-1004 REUSABLE TOTE -BLACK CAMO",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/ed0d118c6c1613c5c497d0e26be8ed245fbabcdc6fbcfea36d46745cdb541146.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.5,
  description: "This reusable tote in black camo from Girlie Girl Originals is a women's tote bag featuring the brand's signature style and southern flair. It offers practical everyday use with a black camo design that complements casual wardrobes. Ideal for boutiques and retailers seeking trend-savvy accessories consistent with Girlie Girl Originals collections.",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:53.998Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
